/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorContactEditorial as ResolvedLabradorContactEditorial } from 'base/components/labrador/ContactEditorial';

export const LabradorContactEditorial: typeof ResolvedLabradorContactEditorial = withLabradorInstanceof((props) => {
    return <ResolvedLabradorContactEditorial {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorContactEditorialProps = PropsFromComponent<typeof LabradorContactEditorial>;
